import React from 'react';

export const getTermsLink = (termType) => {
  const hostname = window.location.hostname.toLowerCase();
  const isVBaby = hostname === 'vbaby.app' || hostname.endsWith('.vbaby.app');

  if (isVBaby) {
    if (termType === 'termsLink') {
      return 'https://documentos.vlabhealth.com/TERMOS-DE-USO-V-BABY.pdf';
    } else if (termType === 'termsPolitic') {
      return 'https://documentos.vlabhealth.com/POLITICADEPRIVACIDADE.pdf';
    } else if (termType === 'termsHealth') {
      return 'https://documentos.vlabhealth.com/TermoDeColetaDeDadosDeSaúde.pdf';
    }
  } else {
    if (termType === 'termsLink') {
      return 'https://documentos.vlabhealth.com/TermosDeUsoAssista.pdf';
    } else if (termType === 'termsPolitic') {
      return 'https://documentos.vlabhealth.com/PoliticaDePrivacidadeAssista.pdf';
    } else if (termType === 'termsHealth') {
      return 'https://documentos.vlabhealth.com/TermoDeColetaDeDadosSaudeAssista.pdf';
    }
  }

  return '';
};

export default function TermsLabel({ label, linkColor = '#5E5E5E' }) {
  const elements = [];
  const termRegex = /\[(\w+)\]([^\[]+)\[\/\1\]/gi;
  let match;
  let lastIndex = 0;

  while ((match = termRegex.exec(label)) !== null) {
    const [fullMatch, termType, termText] = match;
    const precedingText = label.substring(lastIndex, match.index);

    if (precedingText.length > 0) {
      elements.push(precedingText);
    }

    elements.push(
      <a
        key={elements.length}
        href={getTermsLink(termType)}
        rel="noreferrer noopener"
        target="_blank"
        style={{
          color: linkColor,
          fontWeight: 400,
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        {termText}
      </a>
    );

    lastIndex = match.index + fullMatch.length;
  }

  const remainingText = label.substring(lastIndex);
  if (remainingText.length > 0) {
    elements.push(remainingText);
  }

  return <div>{elements}</div>;
}
